export const UPLOAD_BENEFIT_DOCUMENT_FILE_REQUESTED =
  'documents/UPLOAD_BENEFIT_DOCUMENT_FILE_REQUESTED';
